import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://calmbreeze.co.uk";
const DEFAULT_IMAGE = "/calmbreeze-logo.jpg";

const Seo = ({ title, description, path = "", image = DEFAULT_IMAGE, type = "website", jsonLd }) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes("Calmbreeze") ? title : `${title} | Calmbreeze`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Calmbreeze" />
      <meta property="og:locale" content="en_GB" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
